import { render, staticRenderFns } from "./WhatIfScenario.vue?vue&type=template&id=bf37cf52&scoped=true&"
import script from "./WhatIfScenario.vue?vue&type=script&lang=js&"
export * from "./WhatIfScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf37cf52",
  null
  
)

export default component.exports